import styled from "styled-components";

export const SwitchInputHelperText = styled.span`
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 0.5rem !important;
`;